export enum IconEnum {
    IC_CALLBACK = 'ic_callback',
    IC_CLOSE = 'ic_close',
    IC_CHECK = 'ic_yes',
    IC_DELETE = 'ic_delete_outline',
    IC_COLLAPSE_ALL = 'collapse_all_24',
    IC_EXPAND_ALL = 'expand_all_24',
    IC_PLAY = 'ic_play',
    IC_STAR = 'star_24'
}

export enum ImgEnum {
    QUALITY = 'sm_back-quality',
    BANNER = 'banner'
}


export type SaAssets = {
    name: IconEnum | ImgEnum;
    filename: string;
}

export const IMG: SaAssets[] = [
    {
        name: ImgEnum.QUALITY,
        filename: `${ImgEnum.QUALITY}.png`,
    },
    {
        name: ImgEnum.BANNER,
        filename: `${ImgEnum.BANNER}.png`,
    }
];

export const ICONS: SaAssets[] = [
    {
        name: IconEnum.IC_CHECK,
        filename: `${IconEnum.IC_CHECK}.svg`,
    },
    {
        name: IconEnum.IC_DELETE,
        filename: `${IconEnum.IC_DELETE}.svg`,
    },
    {
        name: IconEnum.IC_COLLAPSE_ALL,
        filename: `${IconEnum.IC_COLLAPSE_ALL}.svg`,
    },
    {
        name: IconEnum.IC_EXPAND_ALL,
        filename: `${IconEnum.IC_EXPAND_ALL}.svg`,
    },
    {
        name: IconEnum.IC_PLAY,
        filename: `${IconEnum.IC_PLAY}.svg`,
    },
    {
        name: IconEnum.IC_STAR,
        filename: `${IconEnum.IC_STAR}.svg`,
    },
];
